import { connect } from 'react-redux';
import { ICardEstimateHOCProps } from './types';
import { ICardEstimateEvents, ICardEstimateFields } from '../components/types';
import { IApplicationState } from '../../../../../../../types/types';
import { CardEstimate } from '../components/CardEstimate';
import { getBoardWorkHoursInDay } from '../../../../../../../store/model/selectors/getBoardWorkHoursInDay';
import { getCard } from '../../../../../../../store/model/selectors/getCard';
import { onChange } from './events/onChange';
import { getBoardPermissions } from '../../../../../../../store/model/selectors/getBoardPermissions';
import { TStatus } from '../../../../../../../types/model';
import { onOpen } from './events/onOpen';
import { getCardEstimateString } from '../../../../../../../store/model/helpers/getCardEstimateString';
import {
    parseEstimate
} from '../../../../../aside_panel/cardDetails/EstimateAndSpentTimeSection/components/CardEstimateAndSpentTimeSection/behaviour/parseEstimate';
import { onShowSnackbar } from './events/onShowSnackbar';

const mapStateToProps = (
    state: IApplicationState,
    { cardId, boardId }: ICardEstimateHOCProps
): ICardEstimateFields => {
    const card = getCard(state, cardId);
    const workHoursInDay = getBoardWorkHoursInDay(state, boardId);
    const estimate = getCardEstimateString(card, workHoursInDay);
    return {
        estimate,
        listId: card.listId,
        isDisabled: card.estimate !== parseEstimate(estimate, workHoursInDay),
        isReadonly: !getBoardPermissions(state, boardId).authPermissions.allowEdit,
        isTemplates: card.status === TStatus.STATUS_SERVICE_TEMPLATE,
        workHoursInDay,
    };
};

const mapDispatchToProps = (
    dispatch: any,
    { cardId, setOpen, source }: ICardEstimateHOCProps
): ICardEstimateEvents => {
    return {
        onChange: (estimate) => dispatch(onChange(cardId, estimate, source)),
        onOpen: () => dispatch(onOpen()),
        onShowSnackbar: () => dispatch(onShowSnackbar()),
        setOpen,
    };
};

export const CardEstimateHOC = connect(
    mapStateToProps,
    mapDispatchToProps,
)(CardEstimate);

CardEstimateHOC.displayName = 'CardEstimateHOC';
